/** Main entry point — initializes all modules on DOMContentLoaded */

import { initNavigation } from './modules/navigation'
import { initThemeToggle } from './modules/theme-toggle'
import { initCookieConsent } from './modules/cookie-consent'
import { initTOC } from './modules/toc'
import { initFocusMode } from './modules/focus-mode'
import { initReadingPanels } from './modules/reading-panels'
import { initBackToTop } from './modules/back-to-top'
import { initTableWrap } from './modules/table-wrap'
import { initCodeBlocks } from './modules/clipboard'
import { initSearch } from './modules/search'
import { initAliveTime } from './modules/alive-time'
import { initPagination } from './modules/pagination'
import { initCopyCopyright } from './modules/copy-copyright'
import { initErrorImage } from './modules/error-image'
import { initTextLayout } from './modules/text-layout'
import { initCalendar } from './modules/calendar'
import { initLoopTimeline } from './modules/loop-timeline'
import { initEditorialReading } from './modules/editorial-reading'
import { initHomeJourney } from './modules/home-journey'
import { initSeriesSwitcher } from './modules/series-switcher'
import { initChapterSwitcher } from './modules/chapter-switcher'

document.addEventListener('DOMContentLoaded', () => {
  initNavigation()
  initThemeToggle()
  initCookieConsent()
  initTOC()
  initFocusMode()
  initReadingPanels()
  initBackToTop()
  initTableWrap()
  initCodeBlocks()
  initSearch()
  initAliveTime()
  initPagination()
  initCopyCopyright()
  initErrorImage()
  initTextLayout()
  initCalendar()
  initLoopTimeline()
  initEditorialReading()
  initHomeJourney()
  initSeriesSwitcher()
  initChapterSwitcher()
})
